<template>
  <v-card tile v-if="document !== null">
    <v-card-title>
      <v-row>
        <v-col
          cols="12"
          class="d-flex justify-space-between"
        >
          <span>Dokument podjetja {{ document.company.title }}</span>
          <v-btn icon @click="editable = true" v-if="editable === false">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click="save" v-else>
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <v-form :readonly="!editable">
            <h1>
              <v-text-field
                label="Identifikator"
                v-model="document.name"
              ></v-text-field>
            </h1>
            <v-autocomplete
              v-model="document.document_type_id"
              :items="documentTypes"
              :search-input.sync="documentTypeSearch"
              @click="loadDocumentTypes"
              item-text="name"
              item-value="id"
              label="Tip dokumenta"
            ></v-autocomplete>
            <v-menu
              v-model="datepickerMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              :disabled="editable === false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="document.valid_until"
                  label="Datum veljavnosti"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="document.valid_until"
                @input="datepickerMenu = false"
              ></v-date-picker>
            </v-menu>
            <v-textarea
              label="Opombe"
              v-model="document.notes"
              outlined
            ></v-textarea>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      datepickerMenu: null,

      document: null,
      documentTypes: [],
      documentTypeSearch: "",
      editable: false,
    }),
    mounted() {
      this.loadDocument();
    },
    methods: {
      loadDocument() {
        this.$http
          .get("api/v1/company-documents/" + this.$route.params.id)
          .then((response) => {
            this.document = response.data;
            this.documentTypes.push(response.data.document_type);
          });
      },
      loadDocumentTypes() {
        if (this.editable === false || this.documentTypes.length > 1) {
          return;
        }
        this.$http.get("api/v1/document-types").then((response) => {
          this.documentTypes = response.data;
        });
      },
      save() {
        this.$http
          .put(
            "api/v1/company-documents/" + this.$route.params.id,
            this.document
          )
          .then((response) => {
            this.document = response.data;
            this.editable = false;
          });
      },
    },
  };
</script>
<style></style>
